export default {
  title: {
    rootcloud: 'ROOTCLOUD',
    headerTitle: window.env.title.en,
    pleaseEnterAccount: 'Please enter account',
    pleaseEnterThePassword: 'Please enter the password',
    logInToTransparentFactoryOperationPlatform: 'Log in to Transparent Factory Operation Platform',
    agree: 'Logging in means that you have agreed with ROOTCLOUD platform',
    service: 'Service Agreement',
    privacy: 'Privacy Policy',
    and: 'and',
    account: 'Account',
    password: 'Password',
    forgetPassword: 'Forget password?',
    verificationCodeLogin: 'Verification code login',
    pleaseEnteremailphoneNumber: 'Please enter your username/email/phone number',
    browserTitle: "Equipment Digital Management System",
  },
  route: {
    enterpriseMapMain: 'Enterprise operation',
    enterprise: 'Enterprise management',
    enterpriseInfo: 'Enterprise details',
    addEnterpriseApp: 'App authorization',
    enterpriseMap: 'Enterprise distribution',
    shelvesManage: 'Availability management',
    goodsOnShelves: 'Hardware availability',
    appManagement: 'App availability ',
    applicationItem: 'App details',
    addApplication: 'Add app',
    editApplication: 'Edit app',
    projectWork: 'Project implementation',
    deliveryBatch: 'Delivery batch',
    deliveryList: 'Delivery list',
    modelTemplate: 'Model template'
  },
  navbar: {
    languages: 'Languages',
    logOut: 'Log Out',
    profile: 'Profile'
  },
  sidebar: {
    goHome: 'Back to Homepage'
  },
  login: {
    logIn: 'Login '
  },
  public: {
    username: 'Username',
    password: 'Password',
    edit: 'Edit',
    delete: 'Delete',
    createTime: 'Creation time',
    updateTime: 'Update Time',
    update: 'Update',
    confirm: 'Confirm',
    reset: "Reset",
    cancel: 'Cancel',
    goBack: 'Return',
    bulkImport: 'Bulk Import',
    bulkExport: 'Bulk Export',
    noData: 'No data',
    add: 'Add',
    operation: 'Operation',
    index: 'Number',
    details: 'Details',
    successfullyDeleted: 'SuccessFully deleted',
    successfullyEdited: 'Successfully edited',
    successfullyAdded: 'Successfully added',
    startDate: 'Start Date',
    endDate: 'End Date',
    pleaseEnter: 'Please enter',
    downloadTemplate: 'Download Template',
    import: 'Import',
    fileSize: 'The maximum file size is ',
    fileFormat: 'it supports xls, xlsx format',
    batchExport: 'Batch Export',
    cannotRecovered: 'It cannot be recovered after deletion. Please be careful.',
    downloadImportTemplate: 'Download import template',
    other: 'Other',
    back: 'Back',
    next: 'Next',
    save: 'Save',
    automaticallyGenerated: 'Automatically generated',
    noAvailable: 'N/A',
    pleaseSelect: 'Please select',
    offline: 'Offline',
    online: 'Online',
    inactivated: 'Inactivated',
    device: 'Device',
    gateway: 'Gateway',
    clear: 'Clear',
    enterUsername: 'Please enter username',
    enterCorrectUserName: 'Please enter correct user name. The user name consists of letters, numbers and underscores, with the length of 3-45',
    characterLimit: 'Please enter 8-16 characters, including at least three types of numbers, uppercase letters, lowercase letters, and special characters',
    addressCharacters: 'The address must be 4-128 characters',
    enterCorrectSocialCreditCode: 'Please enter the correct social credit code',
    enterCorrectPhoneNumber: 'Please enter the correct mobile phone number',
    enterCorrectEmail: 'Please enter the correct email',
    enterEnglishNumbers: 'Please enter English, numbers, -_',
    serviceBusy: 'The service is busy. Please refresh the page later and try again!',
    loadMore: "Load more",
    noMore: "No more"
  },
  // 企业管理
  enterprise: {
    enterNameCode: 'Please enter enterprise name and social credit code',
    synchronizeEnterprise: 'Synchronize enterprise',
    enterpriseName: 'Enterprise name',
    enterEnterpriseName: 'Please enter enterprise name',
    unifiedSocialCreditCode: 'Unified social credit code',
    enterUnifiedSocialCreditCode: 'Please enter unified social credit code',
    typeOfEnterprise: 'Type of enterprise',
    selectTypeOfEnterprise: 'Please select type of enterprise',
    address: 'Address',
    enterAddress: 'Please enter address',
    administrator: 'Administrator',
    phoneNumber: 'Phone number',
    enterPhoneNumber: 'Please enter phone number',
    email: 'Email',
    enterEmail: 'Please enter email',
    username: 'Username',
    enterUsername: 'Please enter username',
    password: 'Password',
    enterPassword: 'Please enter password',
    account: 'Account',
    enterAccount: 'Please enter account',
    synchronizeAllUsers: 'Synchronize all users under the enterprise',
    notFound: 'The enterprise information is not found',
    queryInterfaceError: 'Query interface error',
    noEnterpriseInfo: 'No enterprise information. Unable to proceed to the next step',
    registerAdmin: 'Register administrator',
    usernamePassword: 'Username password',
    confirmPassword: 'Confirm password',
    passwordAgain: 'Please enter the password again',
    cannotSame: 'Username and password cannot be the same',
    notMatch: 'The two passwords you entered do not match',
    description: 'Description',
    noDescription: 'Currently no description',
    appIsNotNamed: 'App is not named',
    rootcloud: 'Rootcloud application',
    external: 'External application',
    basicService: 'Basic service',
    backToDetails: 'Back to details',
    addedSuccessfully: 'Application added successfully',
    applicationAuthorization: 'Application authorization',
    cancelAuthorization: 'Cancel authorization',
    appPermissions: 'App permissions',
    wayOfRegister: 'Way of register',
    addEnterprise: 'Add enterprise',
    editEnterprise: 'edit enterprise',
    fillInEnterpriseInfo: 'Fill in enterprise information',
    totalEnterprises: 'Total number of enterprises',
    operator: 'Operator',
    completeEnterpriseInfo: 'Complete enterprise information',
    assignePermissions: 'No app permissions have been assigned. You can add it now',
    confirmCancelAuth: 'Are you sure to cancel the enterprise authorization of this application?',
    addAuthTip: 'There is no app to assign permissions. You can go to software availability to add it.',
    addApp: 'Add app',
    supplier: 'Supplier',
    installer: 'Installer',
    enterpriseUser: 'Enterprise user',
    syncSuccess: 'Synchronized successfully',
    existAdminTip: 'The user already exists and will be added as an administrator of the enterprise',
    adminName: 'Administrator name',
    searchEnterprise: 'Search for enterprise',
    enterAdminName: 'Please enter administrator name',
    selectAssetCategory: 'Please select asset category',
    assetName: 'Asset name',
    assetCode: 'Asset code',
    assetCategory: 'Asset category',
    status: 'Status',
    enterAssetNameAndCode: 'Please enter asset name and code',
    hasBeenSelected: '{0} item on this page has been selected',
    updatedSuccessfully: 'Updated successfully',
  },
  // 项目实施-发货批次
  deliveryBatch: {
    importInformation: 'Import information',
    deliveryBatch: 'Delivery batch',
    numberOfDeliveries: 'Number of deliveries',
    deliveryCompany: 'Delivery company',
    trackingNumber: 'Tracking number',
    recipient: 'Recipient',
    contact: 'Contact',
    deliveryAddress: 'Delivery address',
    deliveryTime: 'Delivery time',
    importedTime: 'Imported time',
    selectLocalFile: 'Select local file'
  },
  // 项目实施-发货清单
  deliveryList: {
    deliveryBatch: 'Delivery batch',
    serialNumber: 'Serial number',
    productSubcategory: 'Product subcategory',
    productModel: 'Product model',
    detailedSpecifications: 'Detailed specifications',
    supplier: 'Supplier',
    SIMCardNumber: 'SIM card number',
    endUser: 'End user',
    installationStatus: 'Installation status',
    installationTime: 'Installation time',
    installed: 'Installed',
    notInstalled: 'Not Installed',
    deviceVersion: 'Device version',
    deliveryManager: 'Delivery manager',
    projectCode: 'Project code'
  },
  // 硬件上架
  hardwareAvailability: {
    productCategory: 'Product category',
    productSubcategory: 'Product subcategory',
    productModel: 'Product model',
    supplier: 'Supplier',
    authenticationKey: 'Authentication key',
    objectModel: 'Object model',
    productAvailability: 'Product availability',
    newProductCategory: 'New product category',
    whetherDeleteProduct: 'Are you sure you want to delete this product category?',
    notFoundSupplier: 'The supplier information was not found',
    selectProductCategory: 'Please select product category',
    selectProductSubCategory: 'Please select product sub-category',
    enterSupplierName: 'Please enter supplier name',
    enterAuthKey: 'Please enter authentication key',
    enterProductModel: 'Please enter product model',
    selectObjectModel: 'Please select object model',
    authKeyLength: 'The length of the authentication key is 8-512 bits',
    hardwareSearchPlaceholder: 'Please enter product category, sub-category, product model and supplier'
  },
  appManagement: {
    basicService: 'Basic service',
    rootApplication: 'Rootcloud application',
    externalApplication: 'External application',
    addApplication: 'Add application',
    appIsNotNamed: 'App is not named',
    noDescription: 'No description',
    description: 'Description',
    noApplication: 'No application yet. You can add it now.',
    whetherDeleteApp: 'Are you sure you want to delete this app?',
    deleteTipText: 'If you delete it, you will no longer be able to view this app, and the content of the app will be deleted.',
    iconManager: 'Icon management',
    fileSizeIskSupporting: 'The maximum file size is 128k, supporting jpg and png formats',
    applicationCode: 'Application code',
    fillInApplicationCode: 'Please fill in the application code',
    applicationName: 'Application name',
    fillInApplicationName: 'Please fill in the application name',
    applicationAddress: 'Application address',
    fillInApplicationAddress: 'Please fill in the application address',
    applicationCategory: 'Application category',
    selectApplicationCategory: 'Please select application category',
    whetherToOpenTheTag: 'Whether to open the tag',
    no: 'No',
    yes: 'Yes',
    applicationSource: 'Application source',
    enterDescription: 'Please enter description',
    cancel: 'Cancel',
    confirm: 'Confirm',
    onlyBeLetterNumberAnd: 'The code can only be letter, number, "_" and "-".',
    cancelTheNewApplication: 'Are you sure you want to cancel the new application?',
    cannotReturnToPreviousPage: 'After canceling, you cannot add an application and return to the previous page.',
    cancelEditingThisApp: 'Are you sure you want to cancel editing this app?',
    cancelEditingWillNotBeAbleToUpdate: 'If you cancel editing this app, you will not be able to update the content of this app.',
    enterTheApplicationCode: 'Please enter the application code',
    enterTheApplicationName: 'Please enter the application name',
    chooseWhetherToOpenTheTag: 'Please choose whether to open the tag',
    selectApplicationSource: 'Please select application source',
    selectApplicationType: 'Please select application type',
    theSizeOfTheUploadedAvatarImage: 'The size of the uploaded avatar image cannot exceed 128kb!',
    search: 'Search',
    noData: 'No data',
    addMenu: 'Add menu',
    exportMenu: 'Export menu',
    importexport: 'Import/Export',
    importMenu: 'Import menu',
    exportTemplate: 'Export template',
    CanImportItNow: 'There is no menu yet. You can import it now.',
    basicInformation: 'Basic Information',
    menuName: 'Menu name',
    icon: 'Icon',
    menuCode: 'Menu code',
    addressBarRouting: 'Address bar routing',
    resourcePath: 'Resource path',
    wantToDeleteThisMenu: 'Are you sure you want to delete this menu?',
    menuContentsWillBeDeleted: 'This menu cannot be viewed after deletion, and the lower-level menus and menu contents will also be deleted.',
    wantToDeleteTheData: 'Are you sure you want to delete the data?',
    deletedDatanotRecovered: 'The deleted data cannot be recovered.',
    templateExportedSuccessfully: 'Template exported successfully',
    theHighestMenuLevelIsFive: 'The highest menu level is 5!',
    theMenuIsImportedSuccessfully: 'The menu is imported successfully!',
    theMenuIsExportedSuccessfully: 'The menu is exported successfully!',
    currentMenu: 'Current menu',
    selectNewMenuLevel: 'Select new menu level',
    pleaseSelectMenuLevel: 'Please select menu level',
    sameLevelMenu: 'Same level menu',
    lowerlevelMenu: 'Lower-level menu',
    enterMenuName: 'Please enter menu name',
    enterMenuCode: 'Please enter menu code',
    duplicateMenuCode: 'Duplicate menu code',
    pleaseEnterMenuLevel: 'Please enter menu level',
    code: 'Code',
    pleaseEnterCode: 'Please enter code',
    name: 'Name',
    pleaseEnterName: 'Please enter name',
    requestCategory: 'Request category',
    pleaseSelectRequestCategory: 'Please select request category',
    address: 'Address',
    pleaseEnterAddress: 'Please enter address',
    codeDuplicated: 'Code duplicated',
    editMenu: 'Edit menu',
    pleaseEnterAddressBarRouting: 'Please enter address bar routing',
    pleaseEnterResourcePath: 'Please enter resource path',
    theSizeOfTheUploadedAvatarImageCannotExceedmb: 'The size of the uploaded avatar image cannot exceed 1MB!'
  }
}
